window.capacityCart = (function() {
  var CREATINE_HYDRATION_VARIANT_ID = 52820531544373;
  var PURE_CREATINE_VARIANT_ID = 52988037693749;
  // Each product has its OWN subscription selling plan — they are not interchangeable.
  var CREATINE_HYDRATION_SELLING_PLAN = 710753747253;
  var PURE_CREATINE_SELLING_PLAN = 710830096693;
  // Back-compat alias (hydration plan)
  var CREATINE_SELLING_PLAN = CREATINE_HYDRATION_SELLING_PLAN;

  function isOnPureCreatinePage() {
    return window.location.pathname.indexOf('pure-creatine-monohydrate') !== -1;
  }

  function getCreatineVariantId() {
    return isOnPureCreatinePage() ? PURE_CREATINE_VARIANT_ID : CREATINE_HYDRATION_VARIANT_ID;
  }

  function getCreatineSellingPlan() {
    return isOnPureCreatinePage() ? PURE_CREATINE_SELLING_PLAN : CREATINE_HYDRATION_SELLING_PLAN;
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else {
      customElements.whenDefined('cart-drawer-component').then(function() {
        if (typeof drawer.open === 'function') drawer.open();
      }).catch(function() {});
    }
  }

  function setToggleState(isSubscription) {
    var scope = document.querySelector('cart-drawer-component');
    if (!scope) return;

    var track = scope.querySelector('.ch-d-toggle__track');
    if (!track) return;

    var labels = scope.querySelectorAll('.ch-d-toggle__label');
    var otpLabel = labels[0];
    var subLabel = labels[1];

    if (isSubscription) {
      track.classList.add('is-sub');
      if (otpLabel) otpLabel.classList.remove('is-active');
      if (subLabel) subLabel.classList.add('is-active');
    } else {
      track.classList.remove('is-sub');
      if (otpLabel) otpLabel.classList.add('is-active');
      if (subLabel) subLabel.classList.remove('is-active');
    }
  }

  async function addAndCheckout(sellingPlan, variantId, isSubscription) {
    var payload = { id: variantId, quantity: 1 };
    if (sellingPlan) payload.selling_plan = sellingPlan;

    // 1. Always clear cart first
    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });
    } catch(e) {}

    // 2. Add to cart
    var added = false;
    var responseText = '';
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      });
      added = res.ok;
      if (!added) { try { responseText = await res.text(); } catch(e) {} }
    } catch(e) { responseText = String(e); }

    // 3. If first add failed, retry once after 500ms
    if (!added) {
      await new Promise(function(r) { setTimeout(r, 500); });
      try {
        var res2 = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        });
        added = res2.ok;
        if (!added) { try { responseText = await res2.text(); } catch(e) {} }
      } catch(e) { responseText = String(e); }
    }

    if (!added) {
      alert('Cart error: ' + responseText);
      return;
    }

    // 4. Refresh cart state and VERIFY the item is actually in the cart.
    //    A 200 response is NOT proof of success — e.g. a Cloudflare interstitial
    //    can return 200 HTML without adding anything, which would otherwise open
    //    an empty drawer. Only proceed if /cart.js confirms a non-empty cart.
    var cartData = null;
    try {
      var cartRes = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });
      cartData = await cartRes.json();
    } catch(e) {}

    if (!cartData || !cartData.item_count) {
      alert('Cart error: the item could not be added to your cart. Please try again.');
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cartData, sourceId: null, data: {} }
    }));
    if (window.capacityDrawerUI && typeof window.capacityDrawerUI.renderAll === 'function') {
      window.capacityDrawerUI.renderAll(cartData);
    }

    // 5. Drawer opens ONLY after a confirmed, non-empty cart
    openDrawer();

    // 6. Force toggle to match what was clicked
    setToggleState(isSubscription);
  }

  return {
    creatineSubscribe: function() { addAndCheckout(getCreatineSellingPlan(), getCreatineVariantId(), true); },
    creatineOtp: function() { addAndCheckout(null, getCreatineVariantId(), false); },
    pureCreatineSubscribe: function() { addAndCheckout(PURE_CREATINE_SELLING_PLAN, PURE_CREATINE_VARIANT_ID, true); },
    pureCreatineOtp: function() { addAndCheckout(null, PURE_CREATINE_VARIANT_ID, false); }
  };
})();
